<template>
  <div class="parking-existing-select" :aria-busy="isLoading">
    <SpinnerLoading v-if="isLoading" color="blue" />
    <div v-else-if="loadError" role="alert">
      <p>{{ loadError }}</p>
      <CamsButton @click="loadParkings">Повторить</CamsButton>
    </div>
    <template v-else-if="availableParkings.length">
      <SmartSelect
        v-model="selectedParkingId"
        :options="filteredParkings"
        caption="Существующая парковка"
        placeholder="Выберите парковку"
        empty-value="Парковки не найдены"
        label-field="name"
        value-field="id"
        width="fill"
      >
        <template #option="{option}">
          {{ option.label }} · № {{ option.key }}
        </template>
      </SmartSelect>
    </template>
    <p v-else>Нет парковок, доступных для добавления в этот комплекс.</p>

    <div class="parking-existing-select__actions">
      <CamsButton @click="$vuedals.close()">Отмена</CamsButton>
      <CamsButton priority="primary" :disabled="isLoading || !selectedParking" @click="addParking">
        Добавить
      </CamsButton>
    </div>
  </div>
</template>

<script>
import {PARKING_FIELDS} from "@/components/pacs/analytics/parkingDetection/parkingComplexConfig.js";
import {ACTION_LOAD_PARKINGS} from "@/store/analytics/parkingDetections/index.js";

export default {
  name: "ParkingExistingSelectDialog",
  props: {
    excludedParkingIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      parkings: [],
      selectedParkingId: "",
      search: "",
      isLoading: false,
      loadError: "",
    };
  },
  computed: {
    availableParkings() {
      const excludedIds = new Set(this.excludedParkingIds.map(String));
      return this.parkings.filter(parking => !parking.is_deleted && !excludedIds.has(String(parking.id)));
    },
    filteredParkings() {
      const query = this.search.trim().toLowerCase();
      return this.availableParkings.filter(parking => (
        String(parking.name || "").toLowerCase().includes(query) || String(parking.id).includes(query)
      ));
    },
    selectedParking() {
      return this.filteredParkings.find(parking => String(parking.id) === String(this.selectedParkingId)) || null;
    },
  },
  created() {
    this.loadParkings();
  },
  methods: {
    async loadParkings() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.loadError = "";
      try {
        const parkings = new Map();
        let page = 1;
        do {
          const response = await this.$store.dispatch(`analytics/parkingDetections/${ACTION_LOAD_PARKINGS}`, {
            page,
            page_size: 100,
            fields: PARKING_FIELDS,
          });
          if (this._isDestroyed || this._isBeingDestroyed) return;
          (response.results || []).forEach(parking => parkings.set(String(parking.id), parking));
          page = response.page && response.page.next;
        } while (page);
        this.parkings = [...parkings.values()];
      } catch (error) {
        this.loadError = error?.fields?.non_field_errors?.[0] || error?.message || "Не удалось загрузить парковки";
      } finally {
        this.isLoading = false;
      }
    },
    addParking() {
      if (this.selectedParking && !this.isLoading) this.$vuedals.close(this.selectedParking);
    },
  },
};
</script>

<style lang="scss" scoped>
.parking-existing-select {
  display: flex;
  width: min(480px, 100%);
  min-height: 180px;
  flex-direction: column;
  gap: 16px;

  &__actions {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: auto;
  }
}
</style>
